import compact from 'lodash/compact';
import flatten from 'lodash/flatten';
import invert from 'lodash/invert';

import { rolesEnum, roleToRoles } from './constants';

export function fullName(user) {
  if (!user) {
    return '';
  }
  return compact([user.firstName, user.lastName]).join(' ');
}

export function withFullName(user) {
  return { ...user, fullName: fullName(user) };
}

export function rolesThatCanBeSetBy(user) {
  return (
    flatten(
      user?.roles.map(
        userRole => roleToRoles[invert(rolesEnum, true)[userRole]] || [],
      ),
    ) || []
  );
}
